<ng-template #drawerContent>
    <div *ngIf="productGroup && showDrawer" class="product-drawer">

        <div class="product-drawer-details" *ngIf="showProduct">
            <product-image imageClass="img-fluid"
                           imageAutomationTag="productImageFeatured"
                           [images]="productGroup.products[productGroup.firstProductId].productImages"
                           imageType="productImage"
                           imageSize="XS"
                           [imageOrder]="0"></product-image>
            <div class="product-details-container">
                <div [innerHTML]="productGroup.products[productGroup.firstProductId].productDescription?.name" class="featured-product-name" automation-tag="featuredProductName">

                </div>
                <div *ngIf="showPricing" class="featured-current-price" automation-tag="featuredCurrentPrice">
                    {{productGroup.products[productGroup.firstProductId]?.price.price | usanacurrency | async}}
                </div>

                <div *ngIf="shouldDisplayVolume && productGroup.products[productGroup.firstProductId].price.volume" class="featured-content">
                    <span translate="cart.product.recommended.volume"></span> {{productGroup.products[productGroup.firstProductId].price.volume}}
                </div>
            </div>
        </div>

        <div class="product-drawer-buttons">
            <button class="button button-medium" addToCart
                    [product]="productGroup.products[productGroup.firstProductId]" [quantity]="1"
                    (productAddedEvent)="openClose.emit(false)"><span
                translate="cart.product.catalog.gridview.addtocart"></span></button>
            <add-ao-dropdown
                *ngIf="!productGroup.hasVariations"
                [addProduct]="productGroup.products[productGroup.firstProductId]"
                [useUpdatedAoList]="true"
                (autoOrderSelected)="openClose.emit(false)"
                btnClass="button button-medium catalog-add-ao"
                [quantity]="1"
                [analyticsName]="'grid'"></add-ao-dropdown>
        </div>

    </div>

</ng-template>

<app-drawer (onOpenClose)="openClose.emit($event)" [visible]="showDrawer" [content]="drawerContent" [drawerClass]="'full-width'"></app-drawer>
